module.exports = "/_next/static/images/intelligence-overview-652b81586f02f2ca84d8f2ade2fe84cf.png";